import { HttpInterceptorFn, HttpErrorResponse, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { Auth } from './auth/auth';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const router = inject(Router);
  const auth = inject(Auth);

  const authReq = req.clone({
    withCredentials: true,
  });

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      const url = req.url;

      const isAuthRoute =
        url.includes('/auth/login') ||
        url.includes('/auth/logout') ||
        url.includes('/auth/me') ||
        url.includes('/auth/csrf');

      if (error.status === 401) {
        auth.clearSessionLocal();

        if (!isAuthRoute) {
          router.navigate(['/login'], {
            queryParams: { returnUrl: router.url, reason: 'unauthorized' },
          });
        }
      } else if (error.status === 403) {
        if (!isAuthRoute) {
          router.navigate(['/home'], {
            queryParams: { error: 'forbidden' },
          });
        }
      } else if (error.status >= 500) {
        console.error('Server error:', error.message);
        // Si es /auth/me y falla el servidor, también redirigir a login
        if (url.includes('/auth/me')) {
          router.navigate(['/login'], {
            queryParams: { returnUrl: router.url, reason: 'server-error' },
          });
        }
      } else if (error.status === 0) {
        console.error('Network error: Unable to connect to server');
        // Si es /auth/me y no hay conexión, redirigir a login
        if (url.includes('/auth/me')) {
          router.navigate(['/login'], {
            queryParams: { returnUrl: router.url, reason: 'network-error' },
          });
        }
      }

      return throwError(() => error);
    })
  );
};